export const PARAMETERART_KONZENTRATION = "KONZENTRATION";
export const PARAMETERART_FRACHT = "FRACHT";
export const PARAMETERART_MENGE = "MENGE";

export function parameterartIdToObj(id) {
    switch (id) {
        case PARAMETERART_KONZENTRATION:
            return { id: PARAMETERART_KONZENTRATION, value: "Konzentration" };
        case PARAMETERART_FRACHT:
            return { id: PARAMETERART_FRACHT, value: "Fracht" };
        case PARAMETERART_MENGE:
            return { id: PARAMETERART_MENGE, value: "Menge" };
        default:
            return null;
    }
}
